import React from "react";
import { withNamespaces } from "react-i18next";

const NewCheckoutLoader = ({ t, isVisible, children }) => {
  return(
    <div className={isVisible ? 'loader is-visible' : 'loader'}>
      <figure>
        <img src="/logo--loader.gif" alt="loader"/>
        {children ? (
          children
        ) : (
          <p className="checkout-loader-wait-text">
            {t('loading_screen_line1')}
            <br/>
            {t('loading_screen_line2')}
          </p>
        )}
      </figure>
    </div>
  )
}

export default withNamespaces()(NewCheckoutLoader);
